import dayjs from 'dayjs'

export const sortByDateTime = (arr, dateKey, timeKey) => {
  if (!arr) return []
  let tmpArray = JSON.parse(JSON.stringify(arr))
  return tmpArray.sort((a, b) => {
    const dateA = dayjs(new Date(a[dateKey])).format('YYYY MM DD')
    const dateB = dayjs(new Date(b[dateKey])).format('YYYY MM DD')
    if (dateA < dateB) return -1
    if (dateA > dateB) return 1
    const timeA = a[timeKey] || '00:00'
    const timeB = b[timeKey] || '00:00'
    const [hoursA, minutesA] = timeA.split(':').map(Number)
    const [hoursB, minutesB] = timeB.split(':').map(Number)
    if (hoursA < hoursB) return -1
    if (hoursA > hoursB) return 1
    if (minutesA < minutesB) return -1
    if (minutesA > minutesB) return 1
    return 0
  })
}

export const isTodaySelected = (rangeFilter) => {
  if (!rangeFilter || rangeFilter.length !== 2) return false
  return (
    dayjs(rangeFilter[0]).format('DD MMMM YYYY') === dayjs().format('DD MMMM YYYY') &&
    dayjs(rangeFilter[1]).format('DD MMMM YYYY') === dayjs().format('DD MMMM YYYY')
  )
}
